<footer>
  <div class="wrapper">
    <p>{{ label | i18next }}</p>
  </div>
</footer>
